export default __webpack_public_path__ + "static/media/third-about.55900eae.png";